import commsSession from './commsSession';
import session from './session';

export default {

  fetchCommsList(filters) {
    return commsSession.get(`/log/query/`, { params: filters,  paramsSerializer: params => new URLSearchParams(params).toString() });
  },

  fetchProductContacts(product_id) {
    return session.get(`/products/${product_id}/contacts/`);
  },

  fetchAccountContacts(account_id) {
    return session.get(`/accounts/${account_id}/contacts/`);
  },

  downloadFreshdeskRecording(recording_url) {
    return session.get(`/freshcaller/download/call-recording/?url=${recording_url}`, { responseType: 'blob' });
  }
}